import { add } from "date-fns"

const getEndDate = (lockPeriod: number): Date => {
  return add(new Date(), { seconds: lockPeriod })
}

export default getEndDate
